import React, { FC } from "react";

type FAQAccordionItemProps = {
  title: string;
  description: string;
};

export const FAQAccordionItem: FC<FAQAccordionItemProps> = ({
  title,
  description,
}) => {
  return (
    <details className="details details__booking mb-1">
      <summary className="details__summary p-2 mb-0">{title}</summary>
      <div
        className="p-2"
        dangerouslySetInnerHTML={{ __html: description }}
      ></div>
    </details>
  );
};
